import { Navigate, Route } from "react-router-dom";

import { routes } from "constants/routes";
import HaulPay from "features/main/HaulPay";
import CreateDirectFR from "features/main/HaulPay/Broker/CreateDirectFR";
import BrokerManagePay from "features/main/HaulPay/Broker/ManagePay";
import BrokerReceivables from "features/main/HaulPay/Broker/Receivables";
// import BrokerFundingRequest from "features/main/HaulPay/Broker/ManagePay/FundingRequest";
import BrokerFundingRequestV2 from "features/main/HaulPay/Broker/ManagePay/FundingRequestV2";
import BrokerMyCarriers from "features/main/HaulPay/Broker/MyCarriers";
import BrokerCarrierAddNew from "features/main/HaulPay/Broker/MyCarriers/AddNew";
import NewCarrierProfileFlow from "features/main/HaulPay/Broker/MyCarriers/AddNew/modules/NewCarrier";
import BrokerInvitedCarrier from "features/main/HaulPay/Broker/MyCarriers/Invited";
import MyCarriers from "features/main/HaulPay/Broker/MyCarriers/Origin";
import BrokerReports from "features/main/HaulPay/Broker/Reports";
import BrokerWallet from "features/main/HaulPay/Broker/Wallet";
import BrokerWalletHistory from "features/main/HaulPay/Broker/Wallet/History";
import BrokerWalletPending from "features/main/HaulPay/Broker/Wallet/Pending";
import OnBoardingSuccess from "features/main/HaulPay/Broker/Wallet/OnBoardingSuccess";
import AssignedLoads from "features/main/HaulPay/Carrier/AssignedLoads";
import AssignedLoadsListByStatusMobile from "features/main/HaulPay/Carrier/AssignedLoads/ListByStatusMobile";
import CarrierManagePay from "features/main/HaulPay/Carrier/ManagePay";
// import CarrierFundingRequest from "features/main/HaulPay/Carrier/ManagePay/FundingRequest";
import CarrierFundingRequestV2 from "features/main/HaulPay/Carrier/ManagePay/FundingRequestV2";
// import CarrierPaymentDetails from "features/main/HaulPay/Carrier/History/PaymentDetails";
import PaymentPreferences from "features/main/HaulPay/Carrier/PaymentPreferences";
import CarrierRequestPay from "features/main/HaulPay/Carrier/RequestPay";
import HaulPayJoin from "features/main/HaulPay/Join";
import FRListByStatusMobile from "features/main/HaulPay/modules/FRListByStatusMobile";
import BulkUploads from "features/main/HaulPay/Shared/BulkUploads";
import Credit from "features/main/HaulPay/Shared/Credit";
import CheckCredit from "features/main/HaulPay/Shared/Credit/Check";
import MyCustomers from "features/main/HaulPay/Shared/Credit/Customers";
import HaulPayStatus from "features/main/HaulPay/Status";
import UploadDocs from "features/main/HaulPay/Status/UploadDocs";
import useDeviceType from "hooks/useDeviceType";
import { useUserFeature } from "hooks/useUserFeature";

export default function HaulPayRoutes() {
  const {
    isShipper,
    isDispatcher,
    isFactoringApproved,
    isBulkImportAllowed,
    isInvitedCarrier,
    isBrokerSubscribed,
    isCarrierSubscribed,
    isSubscribedUser,
    isWalletEnabled,
    canAccessReceivables
  } = useUserFeature();

  const { isDesktop } = useDeviceType();

  return isFactoringApproved === "approved" || isSubscribedUser ? (
    <Route path={routes.HAULPAY}>
      {!isDesktop && <Route index element={<HaulPay />} />}

      {(isCarrierSubscribed || isInvitedCarrier) && (
        <>
          <Route path="assigned-loads" element={<AssignedLoads />} />
          <Route path="assigned-loads/:status" element={<AssignedLoadsListByStatusMobile />} />
          <Route
            path="assigned-loads/payment-details/:fundingRequestId"
            element={<CarrierFundingRequestV2 isAssignedLoad />}
          />
        </>
      )}

      {isCarrierSubscribed && <Route path="request-pay" element={<CarrierRequestPay />} />}
      <Route path="reports" element={<BrokerReports />} />
      <Route path="carrier">
        <Route path="funding-request/:fundingRequestId" element={<CarrierFundingRequestV2 />} />
        <Route path="funding-request-v2/:fundingRequestId" element={<CarrierFundingRequestV2 />} />
        <Route path="manage-pay/" element={<CarrierManagePay />} />
        <Route path="manage-pay/:status" element={<FRListByStatusMobile />} />
        <Route
          path="manage-pay/payment-details/:fundingRequestId"
          element={<CarrierFundingRequestV2 />}
        />
        {isInvitedCarrier ? (
          <Route
            path={routes.HAULPAY_CARRIER_PAYMENT_PREFERENCE}
            element={<PaymentPreferences />}
          />
        ) : null}
        {isBulkImportAllowed && <Route path="bulk-uploads" element={<BulkUploads />} />}
      </Route>

      <Route path="broker">
        <Route path="manage-pay/" element={<BrokerManagePay />} />
        <Route path="manage-pay/:status" element={<FRListByStatusMobile />} />
        {isBrokerSubscribed && isWalletEnabled && (
          <>
            <Route path="wallet" element={<BrokerWallet />}>
              <Route path="" element={<Navigate to="pending" />} />
              <Route path="pending" element={<BrokerWalletPending />} />
              <Route path="history" element={<BrokerWalletHistory />} />
            </Route>
            <Route path="wallet/onboarding-success" element={<OnBoardingSuccess />} />
          </>
        )}
        {(!isBrokerSubscribed || !isWalletEnabled) && (
          <Route
            path="wallet/*"
            element={<Navigate to={routes.HAULPAY_BROKER_MANAGE_PAY} replace />}
          />
        )}
        {isDesktop ? <Route path="bulk-uploads" element={<BulkUploads />} /> : null}
        <Route
          path="receivables"
          element={
            canAccessReceivables ? (
              <BrokerReceivables />
            ) : (
              <Navigate to={routes.HAULPAY_BROKER_MANAGE_PAY} replace />
            )
          }
        />
        <Route path="funding-request/:fundingRequestId" element={<BrokerFundingRequestV2 />} />
        <Route path="funding-request-v2/:fundingRequestId" element={<BrokerFundingRequestV2 />} />
        <Route path="carriers" element={<BrokerMyCarriers />}>
          <Route path="" element={<Navigate to="origin" />} />
          <Route path="origin" element={<MyCarriers />} />
          <Route path="invited" element={<BrokerInvitedCarrier />} />
        </Route>
        <Route path={routes.HAULPAY_BROKER_CARRIERS_NEW} element={<BrokerCarrierAddNew />} />
        <Route path={routes.HAULPAY_BROKER_CARRIERs_NEW_FLOW} element={<NewCarrierProfileFlow />} />

        <Route path={routes.HAULPAY_BROKER_FUNDING_REQUEST} element={<CreateDirectFR />} />
      </Route>

      <Route path="credit" element={<Credit />}>
        <Route path="" element={<Navigate to="check" />} />
        <Route path="check" element={<CheckCredit />} />
        <Route path="customers" element={<MyCustomers />} />
      </Route>
    </Route>
  ) : (
    <>
      {!isShipper && !isDispatcher && (
        <>
          <Route path={routes.HAULPAY_JOIN} element={<HaulPayJoin />} />
          <Route path={routes.HAULPAY_STATUS} element={<HaulPayStatus />} />
          <Route path={routes.HAULPAY_UPLOAD_DOCS} element={<UploadDocs />} />
        </>
      )}

      {isInvitedCarrier && (
        <Route path={routes.HAULPAY}>
          {!isDesktop && <Route index element={<HaulPay />} />}
          <Route path="assigned-loads" element={<AssignedLoads />} />
          <Route path="assigned-loads/:status" element={<AssignedLoadsListByStatusMobile />} />
          <Route
            path="assigned-loads/payment-details/:fundingRequestId"
            element={<CarrierFundingRequestV2 isAssignedLoad />}
          />
          <Route
            path={routes.HAULPAY_CARRIER_PAYMENT_PREFERENCE}
            element={<PaymentPreferences />}
          />
        </Route>
      )}
    </>
  );
}
